module.exports = "<div class=\"wrapper-main\">\r\n    <div class=\"main-content\">\r\n        <h1 class=\"main-title\"> {{this.title}}</h1>\r\n          <child-element  (entityOutPut)=\"selectChild($event)\" [title]=\"childTitle\" [entityChildlist]=\"organizationList\"> </child-element>\r\n    </div>\r\n</div>\r\n<selected-child-component [entitySelectElement]=\"entityselectChild\"> </selected-child-component>\r\n\r\n  \r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityList/entity-list.component.html
// module id = ../../../../../src/app/private/entity/entityList/entity-list.component.html
// module chunks = main